import Config from 'config/Config';
import { makeAutoObservable } from 'mobx';
import { DO_AUTHORIZE_SSE, SSE_STREAM } from 'network/shared/sse';

import { SseCategoryT } from 'types/shared/core/Sse';
import { EmptyRequestT } from 'types/shared/reqAndRes/CommonRequest';
import { MyResponse } from 'types/shared/reqAndRes/MyResponse';
import { api } from 'utils/api/api';
import { MyError } from 'utils/MyError';

export default class SseStore {
  academyId: number;
  category: SseCategoryT;
  private es: EventSource | null = null;
  private authorizeTimer: number | null = null;
  eventHandler: (ev: MessageEvent) => void;

  constructor(
    academyId: number,
    category: SseCategoryT,
    eventHandler: (ev: MessageEvent) => void,
  ) {
    this.academyId = academyId;
    this.category = category;
    this.eventHandler = eventHandler;
    makeAutoObservable(this);
  }

  private supportsSSE(): boolean {
    return typeof window.EventSource === 'function';
  }

  init = async () => {
    console.log('sse store init');
    if (!this.supportsSSE()) {
      console.warn(
        'SSE not supported in this environment — falling back to polling.',
      );
      // TODO: kick off your fallback mechanism here
      return;
    }

    await this.authorize();
    console.log('a');
    this.authorizeTimer = window.setInterval(this.authorize, 100_000);
    console.log('b');
    const path = SSE_STREAM(this.academyId, this.category);
    const url = `${Config.apiBaseUrl}${path}`;
    console.log('url', url);
    this.es = new EventSource(url, { withCredentials: true });
    console.log('c');
    this.es.onopen = () => {
      console.log('✅ SSE connected to', url);
    };

    this.es.addEventListener(this.category, this.eventHandler);

    this.es.onerror = (err) => {
      console.error('SSE connection lost. Reconnecting…', err);
    };
    console.log('d');
  };

  deinit = () => {
    if (this.authorizeTimer !== null) {
      clearInterval(this.authorizeTimer);
      this.authorizeTimer = null;
    }
    if (this.es && this.eventHandler) {
      this.es.removeEventListener(this.category, this.eventHandler);
    }
    if (this.es) {
      this.es.close(); // closes network connection
      this.es = null;
    }
  };

  authorize = async () => {
    try {
      const result = await api<EmptyRequestT, MyResponse<void>>(
        DO_AUTHORIZE_SSE(this.academyId, this.category),
        {},
      );
      if (result.isSuccess) {
        console.log('auth success');
      } else {
        console.log('auth fail');
      }
    } catch (e) {
      await MyError.handleCatchedError(e);
    }
  };
}
